var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sub-page"},[_c('top-section',{attrs:{"navs":_vm.navs,"title":_vm.nav_title}}),_c('nredc-survey')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }